"use client";

import { c as _c } from "react/compiler-runtime";
import { ProgressBarLink } from "@/components/progress-bar";
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuSubMenu, DropdownMenuSubMenuContent, DropdownMenuSubMenuTrigger } from "@/components/ui/dropdown";
import { useIsMobileOrTablet } from "@/hooks/use-is-touch-device";
import type { SectionMenu } from "@/lib/menu-access";
interface SectionSubMenuProps {
  /** The section's own name — "Settings", "Analytics". */
  name: string;
  /** The section landing page, listed first as "All <name>". */
  route: string;
  menu: SectionMenu;
}

/**
 * One sub-nav section inside the profile menu. Settings and Analytics render
 * through this from their sitemap config, so neither is a special case.
 */
export function SectionSubMenu(t0) {
  const $ = _c(25);
  const {
    name,
    route,
    menu
  } = t0;
  const isTouch = useIsMobileOrTablet();
  if (menu.entries.length === 0 && menu.groups.length === 0) {
    let t1;
    if ($[0] !== name) {
      t1 = <DropdownMenuItem>{name}</DropdownMenuItem>;
      $[0] = name;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== route || $[3] !== t1) {
      t2 = <ProgressBarLink href={route}>{t1}</ProgressBarLink>;
      $[2] = route;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  let t1;
  if ($[5] !== isTouch || $[6] !== name || $[7] !== route) {
    t1 = <DropdownMenuSubMenuTrigger className="w-full" arrowPosition="none">{isTouch ? <span>{name}</span> : <ProgressBarLink href={route} className="w-full">{name}</ProgressBarLink>}</DropdownMenuSubMenuTrigger>;
    $[5] = isTouch;
    $[6] = name;
    $[7] = route;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== name) {
    t2 = <DropdownMenuItem>All {name}</DropdownMenuItem>;
    $[9] = name;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== route || $[12] !== t2) {
    t3 = <ProgressBarLink href={route}>{t2}</ProgressBarLink>;
    $[11] = route;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== menu.entries) {
    t4 = menu.entries.map(_temp);
    $[14] = menu.entries;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== menu.groups) {
    t5 = menu.groups.map(_temp3);
    $[16] = menu.groups;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5) {
    t6 = <DropdownMenuSubMenuContent className="z-[999] ml-2 max-h-[400px] w-60 overflow-y-auto">{t3}{t4}{t5}</DropdownMenuSubMenuContent>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t1 || $[23] !== t6) {
    t7 = <DropdownMenuSubMenu>{t1}{t6}</DropdownMenuSubMenu>;
    $[22] = t1;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp3(group) {
  return <div key={group.name}><DropdownMenuSeparator /><DropdownMenuLabel className="py-1">{group.name}</DropdownMenuLabel>{group.entries.map(_temp2)}</div>;
}
function _temp2(entry_0) {
  return <ProgressBarLink key={entry_0.route} href={entry_0.route ?? "#"}><DropdownMenuItem><span className="flex-1 truncate">{entry_0.name}</span></DropdownMenuItem></ProgressBarLink>;
}
function _temp(entry) {
  return <ProgressBarLink key={entry.route} href={entry.route ?? "#"}><DropdownMenuItem><span className="flex-1 truncate">{entry.name}</span></DropdownMenuItem></ProgressBarLink>;
}